import type { ReactNode } from "react";
import { Badge, type BadgeTone } from "./Badge";
import { cx } from "./cx";
import { Icon, type IconName } from "./icons";
import s from "./attention.module.css";

export interface AttentionRowProps {
  icon: IconName;
  tone?: "neutral" | "crit" | "warn" | "info";
  title: ReactNode;
  subtitle?: ReactNode;
  /** Either a status badge or a bold figure, not both. */
  badge?: { label: string; tone: BadgeTone };
  figure?: ReactNode;
  action?: ReactNode;
}

export function AttentionRow({ icon, tone = "neutral", title, subtitle, badge, figure, action }: AttentionRowProps) {
  return (
    <div className={s.row}>
      <span className={cx(s.icon, tone !== "neutral" && s[tone])}><Icon name={icon} /></span>
      <div>
        <b className={s.title}>{title}</b>
        {subtitle ? <small className={s.sub}>{subtitle}</small> : null}
      </div>
      {badge ? <Badge tone={badge.tone} dot>{badge.label}</Badge> : <span className={s.figure}>{figure}</span>}
      {action ? <span className={s.action}>{action}</span> : <span />}
    </div>
  );
}
